export default __webpack_public_path__ + "static/media/poster-photo-strip.1f6bc9ed.png";